
export default class ExpandableFilter {
	private expands: string[] = [];
	expand(val: string) {
		this.expands.push(val); 
		return this;	
	}

	getQuery() {
		return {
			'expand': this.expands.join()
		};
	}
}